"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubFolderPage = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const components_1 = require("@alcumus/components");
const PanelSection_1 = __importDefault(require("../shared/PanelSection"));
const folder_1 = require("../../../server/models/folder");
const react_router_dom_1 = require("react-router-dom");
const recoil_1 = require("recoil");
const UpdateFolderModal_1 = __importDefault(require("./UpdateFolderModal"));
const DeleteFolderModal_1 = __importDefault(require("./DeleteFolderModal"));
const useFolderBreadcrumbs_1 = __importDefault(require("./useFolderBreadcrumbs"));
const useCurrentFolder_1 = __importDefault(require("./useCurrentFolder"));
const CreateFolderModal_1 = __importDefault(require("./CreateFolderModal"));
const ReportViewToggle_1 = __importStar(require("../shared/ReportViewToggle"));
const NavBar_1 = __importDefault(require("../NavBar"));
const SubFolderTableView_1 = __importDefault(require("./SubFolderTableView"));
const SubFolderTileView_1 = __importDefault(require("./SubFolderTileView"));
const MoveDashboardModal_1 = __importDefault(require("../Modals/MoveDashboardModal"));
const CreateDashboardModal_1 = __importDefault(require("../Modals/CreateDashboardModal"));
const CreateLookModal_1 = __importDefault(require("../Modals/CreateLookModal"));
const CreateNewButton_1 = __importDefault(require("../Button/CreateNewButton"));
const SubFolderPage = ({ match, }) => {
    const [errorState, setErrorState] = (0, react_1.useState)({ hasError: false, redirectUrl: '' });
    const handleErrors = (err) => {
        if (err.response.status === 404) {
            setErrorState({ hasError: true, redirectUrl: '/notfound' });
        }
        else {
            setErrorState({ hasError: true, redirectUrl: '/error' });
        }
    };
    const folderId = parseInt(match.params.folderId);
    const isMounted = (0, react_1.useRef)(true);
    const [currentFolderActions, setCurrentFolderActions] = (0, react_1.useState)();
    const [isFetchingFolder, currentFolder, folders, dashboards, looks] = (0, useCurrentFolder_1.default)({
        folderId: folderId,
        handleErrorsCallback: handleErrors,
    });
    const [showCreate, setShowCreate] = (0, react_1.useState)(false);
    const [toggleView] = (0, recoil_1.useRecoilState)(ReportViewToggle_1.tableTileViewSwitcherState);
    const shouldDisplayEditSettings = currentFolder?.name && showCreate;
    const [, setCount] = (0, recoil_1.useRecoilState)(ReportViewToggle_1.recordCountTableState);
    const [type] = (0, recoil_1.useRecoilState)(ReportViewToggle_1.recordTypeSwitcherState);
    const [data, setData] = (0, react_1.useState)([
        ...folders,
        ...dashboards,
        ...looks,
    ]);
    const [isFetchingAncestors, folderBreadcrumbs] = (0, useFolderBreadcrumbs_1.default)({
        currentFolder: currentFolder,
    });
    const { t, i18n } = (0, react_i18next_1.useTranslation)(['SubFolderPage', 'TableHeaders']);
    const headers = [
        { id: 'elementType', displayName: t('type', { ns: 'TableHeaders' }) },
        { id: 'name', displayName: t('name', { ns: 'TableHeaders' }) },
        {
            id: 'dashboards',
            displayName: t('dashboards', { ns: 'TableHeaders' }),
            isNumeric: true,
        },
        {
            id: 'looks',
            displayName: t('looks', { ns: 'TableHeaders' }),
            isNumeric: true,
        },
        { id: 'createdBy', displayName: t('owner', { ns: 'TableHeaders' }) },
        {
            id: 'contentFavoriteId',
            displayName: t('favorite', { ns: 'TableHeaders' }),
        },
    ];
    const getCurrentFolderActions = (0, react_1.useCallback)(() => {
        const updateCurrentFolderActions = (res) => {
            if (isMounted.current) {
                setCurrentFolderActions(res);
            }
        };
        (0, folder_1.getAllowedAction)(folderId)
            .then(updateCurrentFolderActions)
            .catch((res) => handleErrors(res));
    }, [folderId]);
    (0, react_1.useEffect)(() => {
        setShowCreate(currentFolder?.can?.edit_content || false);
    }, [currentFolder]);
    (0, react_1.useEffect)(() => {
        isMounted.current = true;
        getCurrentFolderActions();
        return () => {
            isMounted.current = false;
        };
    }, [getCurrentFolderActions]);
    const switchDataType = async () => {
        switch (type) {
            case ReportViewToggle_1.ReportSwitcherTypes.All:
                setData([...folders, ...dashboards, ...looks]);
                setCount(folders.length + dashboards.length + looks.length);
                break;
            case ReportViewToggle_1.ReportSwitcherTypes.Folders:
                setData([...folders]);
                setCount(folders.length);
                break;
            case ReportViewToggle_1.ReportSwitcherTypes.Dashboards:
                setData([...dashboards]);
                setCount(dashboards.length);
                break;
            case ReportViewToggle_1.ReportSwitcherTypes.Looks:
                setData([...looks]);
                setCount(looks.length);
                break;
            default:
                setData([...folders, ...dashboards, ...looks]);
                setCount(folders.length + dashboards.length + looks.length);
                break;
        }
    };
    (0, react_1.useEffect)(() => {
        switchDataType();
    }, [type, folders, looks, dashboards]);
    if (errorState.hasError) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: errorState.redirectUrl });
    }
    const getSubtitle = () => {
        if (currentFolder?.isPersonal)
            return t('personalFolder');
        if (`${currentFolder?.parentId}` ===
            localStorage.getItem('application_root_folder_id'))
            return t('alcumusLibrary');
        if (`${currentFolder?.externalId}` ===
            localStorage.getItem('user_external_group_id'))
            return t('orgFolder');
    };
    return (react_1.default.createElement(components_1.TranslateReady, { tReady: i18n.isInitialized },
        react_1.default.createElement(NavBar_1.default, null,
            react_1.default.createElement(PanelSection_1.default, { isLoading: isFetchingFolder || isFetchingAncestors, panelSettings: shouldDisplayEditSettings && react_1.default.createElement(CreateNewButton_1.default, { buttonSize: "sm" }), subTitle: getSubtitle(), routes: folderBreadcrumbs, enableEdit: currentFolderActions?.canUpdate, enableDelete: currentFolderActions?.canDelete, currentFolderId: currentFolder?.id },
                react_1.default.createElement(ReportViewToggle_1.default, null),
                react_1.default.createElement("br", null),
                folderId && toggleView === 'table' && (react_1.default.createElement(SubFolderTableView_1.default, { data: data, headers: headers, showOwner: true, showDashboardCount: true, showLookCount: true, showFavorite: true, isLoading: isFetchingFolder || isFetchingAncestors, showCreateButton: showCreate })),
                folderId && toggleView === 'tile' && (react_1.default.createElement(SubFolderTileView_1.default, { folders: folders, dashboards: dashboards, looks: looks, isLoading: isFetchingFolder || isFetchingAncestors, headers: headers.map((header) => header.displayName), showCreateButton: showCreate }))),
            showCreate && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(CreateFolderModal_1.default, { defaultFolderId: currentFolder?.id ?? -1 }),
                react_1.default.createElement(CreateDashboardModal_1.default, { defaultFolderId: currentFolder?.id ?? -1 }),
                react_1.default.createElement(CreateLookModal_1.default, { defaultFolderId: currentFolder?.id ?? -1 }))),
            shouldDisplayEditSettings && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(UpdateFolderModal_1.default, { currentFolderName: currentFolder?.name, defaultFolderId: currentFolder?.id ?? -1, parentId: currentFolder?.parentId ?? -1 }))),
            react_1.default.createElement(MoveDashboardModal_1.default, null),
            react_1.default.createElement(DeleteFolderModal_1.default, null))));
};
exports.SubFolderPage = SubFolderPage;
exports.default = exports.SubFolderPage;
